import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsPage() {
  const testimonials = [{
    quote: 'Continuum Talent Solutions changed my career trajectory completely. Within 6 weeks I had 3 offers!',
    author: 'Sarah M.',
    role: 'Senior Director',
    company: 'Fortune 500',
    rating: 5
  }, {
    quote: 'Their resume team is incredible. My interviews tripled after the rewrite.',
    author: 'James T.',
    role: 'Cloud Architect',
    company: 'Google',
    rating: 5
  }, {
    quote: 'I was stuck for 2 years. Continuum Talent Solutions placed me in 30 days.',
    author: 'Priya K.',
    role: 'Healthcare Admin',
    company: 'Major Hospital',
    rating: 5
  }, {
    quote: 'Professional, timely, and truly invested in my success. Highly recommend.',
    author: 'Michael R.',
    role: 'Software Engineer',
    company: 'StartUp Inc',
    rating: 5
  }, {
    quote: 'The interview prep was a game changer. I went in feeling 100% ready.',
    author: 'Elena G.',
    role: 'Product Manager',
    company: 'Tech Giant',
    rating: 4
  }, {
    quote: 'Worth every penny. The ROI on my new salary paid for the service in one paycheck.',
    author: 'David L.',
    role: 'Sales VP',
    company: 'Global Corp',
    rating: 5
  }];
  return <div className="pt-20" data-id="element-445" data-mp="2yu0doj1oylyg">
      {/* Hero */}
      <section className="bg-navy-900 text-white py-20 text-center" data-id="element-446" data-mp="2yt73f83ixebk">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-447" data-mp="2urvmdqypu1ez">
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-448" data-mp="2uqaopsh3u2cw">
            Client Success Stories
          </h1>
          <div className="flex justify-center items-center space-x-2 mb-4" data-id="element-449" data-mp="2ktxyj4krq6mw">
            <div className="flex text-gold-500" data-id="element-450" data-mp="2kw22fmio35n6">
              {[...Array(5)].map((_, i) => <Star key={i} className="h-6 w-6 fill-current" data-id="element-451" data-mp="2fxh09hjuubw3" data-mpi={i} />)}
            </div>
            <span className="text-2xl font-bold" data-id="element-452" data-mp="269lf1acprtqx">4.9/5</span>
          </div>
          <p className="text-gray-300" data-id="element-453" data-mp="2b86idin9itjl">Based on 500+ reviews</p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-20 bg-gray-50" data-id="element-454" data-mp="1x8ne50xko2ck">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455" data-mp="217w55y189m4f">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-456" data-mp="21a8vozl1x4t3">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-457" data-mp="2txmja72v0o0j" data-mpi={index}>
                <Quote className="h-8 w-8 text-gold-200 mb-4" data-id="element-458" data-mp="117arbps9ramt" />
                <p className="text-gray-700 mb-6 italic text-lg" data-id="element-459" data-mp="wa2bhvulfioq">"{t.quote}"</p>
                <div className="flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-460" data-mp="1ayf6oqluwxi6">
                  <div data-id="element-461" data-mp="15zc0v3y1yn95">
                    <div className="font-bold text-navy-900" data-id="element-462" data-mp="15z2a3e56oc2e">{t.author}</div>
                    <div className="text-sm text-gray-500" data-id="element-463" data-mp="i9reeb2ox7v4">{t.role}</div>
                    <div className="text-xs text-gray-400" data-id="element-464" data-mp="ibu5yzjhr91y">{t.company}</div>
                  </div>
                  <div className="flex text-gold-500" data-id="element-465" data-mp="dcrcmccvir9t">
                    {[...Array(t.rating)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" data-id="element-466" data-mp="n8uc1agccbt2" data-mpi={i} />)}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}